// extracted by mini-css-extract-plugin
module.exports = {"wrap":"addressWithSign_wrap__Q3HHB","address":"addressWithSign_address__1_AxC"};